import React, { useContext, useEffect, useState } from "react";
import { PanelContainer } from "../Cpanel/Components/PanelContainer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData, sendPostRequest } from "../Cpanel/Components/Utilities";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import DataTableTemplate from "../Cpanel/Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row } from "react-bootstrap";
import { InputFormat } from "../Landing/Components/FormOptions/InputFormat";
import TelInput from "../Landing/Components/FormOptions/TelInput";
import { ShopContext } from "../StateManagement/Contexts/ShopContext";
import SelectButtonFormat from "../Landing/Components/FormOptions/SelectButtonFormat";
export const ShopCategoryControl = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const province = useSelector((state) => state?.province?.province);
  const [editingShopId, setEditingShopId] = useState(null);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [defaultRows, setDefaultRows] = useState(20);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { shopData } = useContext(ShopContext);
  const [Logo, setLogo] = useState("");
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  const defaultValues = {
    cattitle: "",
    catstatus: 1,
    catpic: "",
    cashback: "",
    catUrl: "",
  };
  const cols = [
    {
      field: "cattitle",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "cattitle",
      header: "نام",
    },
    { field: "cashback", header: "کش بک" },
    {
      field: "catstatus",
      header: "وضعیت",
    },
    {
      field: "webcatid",
      header: "آیدی کتگوری",
    },
    {
      field: "catpic",
      header: "حداقل کش بک",
    },
    {
      field: "catUrl",
      header: "آدرس کتگوری",
    },
    {
      field: "CityName",
      header: "ویرایش",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];
  const handleOpeEditItem = (data) => {
    console.log(data);
    setShowEditComponent(true);
    if (data) {
      setEditingShopId(data?.ShopId);
      reset({ ...defaultValues, ...data });
    } else {
      reset(defaultValues);
      setEditingShopId("");
    }
  };

  const schema = yup.object({
    CatId: yup.string().required("دسته بندی انتخاب نشده است."),
    ManagerId: yup.string().required("مدیر انتخاب نشده است."),
  });

  const statusOptions = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
  ];
  console.log(shopData);
  const {
    watch,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });
  console.log(errors);
  useEffect(() => {
    const handlegetCatResponse = (data) => {
      setPageData(data?.data);
      console.log(data);
    };
    if (shopData?.Token) {
      sendPostRequest(
        "getcat",
        "token",
        shopData?.Token,
        {},
        handlegetCatResponse
      );
    }
  }, [shopData?.Token]);
  const onSubmit = (data) => {
    console.log("data");
    const bodyFormData = new FormData();
    bodyFormData.append("title", data?.title);
    bodyFormData.append("status", data?.status);
    bodyFormData.append("cashback", data?.cashback);
    bodyFormData.append("webcatid", data?.webcatid);
    bodyFormData.append("sort", data?.sort);
    // bodyFormData.append("pic", data?.pic);
    const handleCreateCatResponse = (data) => {
      console.log(data);
    };
    if (shopData?.Token) {
      sendPostRequest(
        "createcat",
        "token",
        shopData?.Token,
        bodyFormData,
        handleCreateCatResponse
      );
    }
  };
  const stOptions = [
    { label: "فعال", value: 1 },
    { label: "غیرفعال", value: 0 },
  ];
  return (
    <PanelContainer title={"دسته بندی ها"}>
      <DataTableTemplate
        lazyState={lazyState}
        // header={header}
        // select='select'
        className={"table-border"}
        columns={cols}
        list={pageData}
        totalRecords={totalRecords}
        setlazyState={setLazyState}
        setDefaultDatatableRows={setDefaultDatatableRows}
        defaultDatatableRows={defaultDatatableRows}
        width="25rem"
      />
      <div className="col-6 mt-5">
        <div className="d-flex flex-row gap-1 mt-2">
          <Button
            className="btn-primary"
            type={"button"}
            onClick={() => handleOpeEditItem()}
          >
            افزودن دسته بندی جدید
          </Button>
        </div>
      </div>
      {showEditComponent && (
        <div className="edit row p-5">
          <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="cattitle"
                  type={"text"}
                  label="نام "
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="cashback"
                  type={"text"}
                  label="حداقل کش بک"
                  errors={errors}
                />
              </Col>
              <Col className="col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="catUrl"
                  type={"text"}
                  label="لینک کتگوری"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  label="آیدی کتگوری در فروشگاه"
                  type="tel"
                  name="webcatid"
                  control={control}
                  defaultValue={""}
                  // maxLength={}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  label="اولویت"
                  name="sort"
                  type="tel"
                  control={control}
                  defaultValue={""}
                />
              </Col>
            </Row>

            <Row>
              <Col> 
                <div className="d-flex flex-direction-column justify-content-start">
                    <Form.Label className="fw-bold pb-1">وضعیت نمایش</Form.Label>
                    <SelectButtonFormat
                      name={"catstatus"}
                      options={stOptions}
                      control={control}
                    />
                  </div>
              </Col>
            </Row>

            <div className="col-6 mt-2">
              <Button type="submit">ذخیره</Button>
            </div>
          </Form>
        </div>
      )}
    </PanelContainer>
  );
};
